import type {
  TArticleCategory,
} from "libs/client/src/lib/articles/categories/types";
import type { TArticle } from "libs/client/src/lib/articles/types";
import type { TPaginationMeta } from "libs/client/src/lib/types";
import { TArticlePath } from "libs/routes/src/lib/routes.types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const ARTICLE_FEED_SECTION_ID = "article-feed";
export const ARTICLE_FEED_LOADING_CARD_COUNT = 12;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TArticleFeedCardsSkeletonProps = {
  cardCount: number;
};

export type TArticleFeedHeaderProps = {
  title?: string;
  body?: string;
};

export type TArticleFeedProps = TArticleFeedHeaderProps & {
  categories?: TArticleCategory[];
  articles?: TArticle[];
  paginationMeta?: TPaginationMeta;
  isArticlesLoading?: boolean;
  isCategoriesLoading?: boolean;
  path: TArticlePath;
};

export type TUseArticleFeed = {
  handlePageChange(page: number): void;
};
